import { Button, Container, Dropdown, Form, Modal, Nav, Table } from 'react-bootstrap';
import {
    faEllipsisVertical,
    faClone,
    faTrash,
    faCancel,
    faMailForward,
    faPhone,
    faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableSkeleton } from '../../../Utils/skeletonLoader/TableSkeleton';
import { useNavigate } from 'react-router-dom';
import nodata from "../../../Utils/assets/img/leads_no_data_found.png";
import { useState } from 'react';
import { DeleteRequest, PostRequest, PutRequest } from '../../../Utils/hooks/ApiHandler';
import { toast } from 'sonner';
import useLocalStorageState from 'use-local-storage-state';
import DeleteModal from '../../DeleteModal';
import { formatDate, maskContactNumber } from '../../../Utils/helpers/commonhelper';
import { Pagination } from './../../../pages/Pagination';
export const QuotationListing = ({ tempFilterData, allQuotation, limit, setLimit, columns, activeOffset, setActiveOffset, quotationData, fetchQuotation, quotationGrant, isLoading, isMyApproval }) => {
    const navigate = useNavigate()
    const [customer, setCustomer] = useLocalStorageState("customer");

    const customer_id = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization || "";
    const rf = customer?.token?.authentication || "";
    const extras = { customer, setCustomer, rf, navigate };
    const headers = {
        Authorization: token,
        Authentication: rf,
    };


    const [openRow, setOpenRow] = useState(null);
    const [departmentToDelete, setDepartmentToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [toCancelQuotation, setToCancelQuotation] = useState();
    const [rejectReason, setRejectReason] = useState("");


    const dataToDisplay =
        tempFilterData !== null ? tempFilterData : allQuotation;
    // pagecount for pagination
    // const pageCount = Math.ceil(quotationData?.total_count / limit);
    const isFiltered = tempFilterData !== null;

    const pageCount = Math.ceil(
        (isFiltered
            ? (dataToDisplay?.length || 0)
            : (quotationData?.total_count || 0)
        ) / limit
    );

    const handleCloseModal = () => {
        setShowModal(false);
        setRejectReason("");
        setLoading(false);
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const payload = {
                quotation_id: toCancelQuotation,
                customer_id: customer_id,
                canceletion_reason: rejectReason,
                user_login_id: customer?.customer_details?.id,
            };
            const res = await PutRequest(
                `quotation/cancelQuotation`,
                payload,
                { headers },
                extras
            );

            if (!res || res.status === "fail") {
                return toast.error(res.message || "something went wrong");
            }
            if (res.status === "success") {
                toast.success(res.message);
                setToCancelQuotation();
                setRejectReason("");

                await fetchQuotation();
                setShowModal(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowModal(false);
            setLoading(false);
            fetchQuotation();
        }
    };

    // Handle page change from react-paginate
    const handlePageChange = (selectedItem) => {
        setActiveOffset(selectedItem.selected);
    };


    // Trigger delete modal
    const onDelete = (id) => {
        setDepartmentToDelete(id);
        setShowDeleteModal(true);
    };

    const handleCancelQuotation = (quotation) => {
        if (!quotation) return;
        setToCancelQuotation(quotation.quotation_id);
        setShowModal(true);
    };

    const handleSendQuotation = async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const payload = {
                quotation_id: id,
                customer_id: customer_id,
                user_login_id: customer?.customer_details?.id,
            };

            const res = await PostRequest(
                `/quotation/sendQuotation`,
                payload,
                false,
                { headers },
                extras
            );

            if (res.status !== "success" || res.status === "fail") {
                return toast.error(res.message);
            }
            toast.success(res.message);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Confirm delete and call API
    const handleConfirmedDelete = async () => {
        setLoading(true)
        try {
            // const item = allQuotation.find(
            //   (d) => d.quotation_id === departmentToDelete
            // );
            const res = await DeleteRequest(
                `quotation/deleteQuotation/${departmentToDelete}/${customer?.customer_details?.id}/${customer_id}`,
                { headers },
                extras
            );

            if (res?.status === "success") {
                toast.success(res.message);
                await fetchQuotation();
            } else if (res.status === "fail") {
                toast.error(res.message);
            }
        } catch (error) {
            console.error("Delete error:", error);
        } finally {
            setLoading(false);
            setShowDeleteModal(false);
            setDepartmentToDelete(null);
        }
    };
    
    return (
        <>
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                        borderRadius: "inherit",
                    }}
                >
                    <div className="d-flex flex-column align-items-center">
                        <div
                            className="spinner-border text-primary"
                            role="status"
                            style={{ width: "3rem", height: "3rem" }}
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="mt-2 text-primary fw-semibold">sending mail</div>
                    </div>
                </div>
            )}

            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 11rem)",
                    backgroundColor: "white",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <div
                        className="listStyleForContact container-table"
                        style={{
                            flex: dataToDisplay?.length > 10 ? 1 : "auto",
                            overflow: "auto",
                            width: "100%",
                            maxHeight: dataToDisplay?.length > 10 ? "100%" : "auto",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.scrollbarColor = "#e0e0e0 white";
                        }}
                    >
                        <Table
                            style={{
                                width: "100%",
                                tableLayout: "auto",
                                backgroundColor: "white",
                                marginBottom: "0px",
                            }}
                        >
                            <thead style={{ zIndex: "10" }}>
                                <tr>
                                    <th>#</th>
                                    {columns?.map((col, index) => (
                                        <th key={`header-${index}`}>{col}</th>
                                    ))}
                                    {!isMyApproval && <th key="actions-header"></th>}
                                </tr>
                            </thead>

                            <tbody style={{ textAlign: "start" }}>
                                {isLoading ? (
                                    <TableSkeleton columnCount={columns.length + 2} />
                                ) : (
                                    <>
                                        {/* {allQuotation && allQuotation.length > 0 ? */}
                                        {dataToDisplay !== null && dataToDisplay?.length === 0 ?
                                            (
                                                <td colSpan={columns.length + 2} style={{ textAlign: "center", color: "gray" }}>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <img
                                                            src={nodata}
                                                            alt=""
                                                            style={{ width: "17rem", marginTop: "0" }}
                                                        />
                                                    </div>
                                                </td>
                                            )
                                            : (
                                                dataToDisplay?.map((quotation, index) => (
                                                    <tr key={quotation.quotation_id || index}>
                                                        {/* Serial number cell */}
                                                        <td>{limit * activeOffset + 1 + index}</td>

                                                        {/* Dynamic cells based on columns order */}
                                                        {columns?.map((col, cellIndex) => {
                                                            // Map column labels to the actual data fields
                                                            switch (col) {
                                                                case "Quotation Number":
                                                                    return (
                                                                        <td
                                                                            key={`cell-${index}-${cellIndex}`}
                                                                            className="text-primary"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() =>
                                                                                navigate(
                                                                                    `/detailquotation/${quotation?.quotation_id}`,
                                                                                    { state: { key2: isMyApproval } }
                                                                                )
                                                                            }
                                                                        >
                                                                            {quotation.quotation_number || "N/A"}
                                                                        </td>
                                                                    );

                                                                case "Contact":
                                                                    return (
                                                                        <td
                                                                            key={`cell-${index}-${cellIndex}`}
                                                                            className="text-primary"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() =>
                                                                                navigate(
                                                                                    `/detailquotation/${quotation?.quotation_id}`,
                                                                                    { state: { key2: isMyApproval } }
                                                                                )
                                                                            }
                                                                        >
                                                                            {quotation.contact_full_name || "N/A"}
                                                                        </td>
                                                                    );

                                                                case "Contact No":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            <FontAwesomeIcon
                                                                                icon={faPhone}
                                                                                className="me-1 text-primary"
                                                                            />
                                                                            {/* {quotation.phone || "N/A"} */}
                                                                            <span style={{ letterSpacing: "0.25px" }}>
                                                                                {maskContactNumber(quotation.phone) || "N/A"}</span>
                                                                        </td>
                                                                    );

                                                                case "Company":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            {quotation.company_name || "N/A"}
                                                                        </td>
                                                                    );

                                                                case "Quotation Date":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            {formatDate(quotation.quotation_date) || "-"}
                                                                        </td>
                                                                    );

                                                                case "Expiry Date":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            {quotation.expiry_date
                                                                                ? (() => {
                                                                                    const today = new Date();
                                                                                    const expiry = new Date(quotation.expiry_date);
                                                                                    let bgColor = "";
                                                                                    if (expiry < today) bgColor = "#f8d3d5";
                                                                                    else if (expiry > today) bgColor = "#c0f7b8";
                                                                                    else bgColor = "#f9f0ce";

                                                                                    return (
                                                                                        <span
                                                                                            style={{
                                                                                                display: "inline-block",
                                                                                                backgroundColor: bgColor,
                                                                                                color: "#444040",
                                                                                                padding: "0px 6px",
                                                                                                borderRadius: "20px",
                                                                                                fontSize: "12px",
                                                                                                fontWeight: "400",
                                                                                            }}
                                                                                        >
                                                                                            {formatDate(quotation.expiry_date)}
                                                                                        </span>
                                                                                    );
                                                                                })()
                                                                                : "-"}
                                                                        </td>
                                                                    );

                                                                case "Lead Owner":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            {quotation.owner_full_name || "-"}
                                                                        </td>
                                                                    );

                                                                case "Deal":
                                                                    return (
                                                                        <td key={`cell-${index}-${cellIndex}`}>
                                                                            {quotation.deal_name || "N/A"}
                                                                        </td>
                                                                    );

                                                                case "Quotation Status":
                                                                    return (
                                                                        <td
                                                                            key={`cell-${index}-${cellIndex}`}
                                                                            style={{
                                                                                textTransform: "capitalize",
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    textTransform: "capitalize",
                                                                                    color:
                                                                                        quotation.quotation_status === "pending"
                                                                                            ? "#a28414"
                                                                                            : quotation.quotation_status === "draft"
                                                                                                ? "#1f7a96"
                                                                                                : quotation.quotation_status === "cancel"
                                                                                                    ? "#9e1920"
                                                                                                    : quotation.quotation_status === "approved"
                                                                                                        ? "#239b11"
                                                                                                        : quotation.quotation_status === "reject"
                                                                                                            ? "#4f575b"
                                                                                                            : "#999",
                                                                                    borderRadius: "12px",
                                                                                    padding: "1.5px 6px",
                                                                                    backgroundColor:
                                                                                        quotation.quotation_status === "pending"
                                                                                            ? "#f9f0ce"
                                                                                            : quotation.quotation_status === "draft"
                                                                                                ? "#ceecf5"
                                                                                                : quotation.quotation_status === "cancel"
                                                                                                    ? "#f8d3d5"
                                                                                                    : quotation.quotation_status === "approved"
                                                                                                        ? "#c0f7b8"
                                                                                                        : quotation.quotation_status === "reject"
                                                                                                            ? "#d2d6d8"
                                                                                                            : "",
                                                                                }}
                                                                            >
                                                                                {quotation.quotation_status || "N/A"}
                                                                            </span>
                                                                        </td>
                                                                    );

                                                                default:
                                                                    return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                                                            }
                                                        })}

                                                        {/* Actions column */}
                                                        {!isMyApproval && (
                                                            <td
                                                                key={`actions-${index}`}
                                                                className="lastactionTd"
                                                                style={{
                                                                    "--pad": "14px",
                                                                    paddingRight: "var(--pad) !important",
                                                                    paddingLeft: "var(--pad) !important",
                                                                    zIndex: openRow === quotation.quotation_id ? 11 : "auto",
                                                                }}
                                                            >
                                                                <div className="endTdDiv">
                                                                    <Dropdown
                                                                        as="div"
                                                                        className="dropdownsWithoutToggle"
                                                                        onToggle={(isOpen) =>
                                                                            setOpenRow(isOpen ? quotation.quotation_id : null)
                                                                        }
                                                                    >
                                                                        <Dropdown.Toggle as={Nav.Link} className="header-link">
                                                                            <FontAwesomeIcon
                                                                                className="text-muted"
                                                                                style={{
                                                                                    width: "15px",
                                                                                    height: "15px",
                                                                                    color: "#536485",
                                                                                }}
                                                                                icon={faEllipsisVertical}
                                                                            />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu
                                                                            align={"end"}
                                                                            style={{
                                                                                width: "8rem",
                                                                                inset: "0px auto auto 0px",
                                                                                boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                                                position: "absolute",
                                                                                marginTop: "-22px",
                                                                                marginRight: "25px",
                                                                                minWidth: "3rem",
                                                                            }}
                                                                        >
                                                                            {/* Keep your existing dropdown items here */}
                                                                            {quotation.quotation_status === "approved" ? (
                                                                                ""
                                                                            ) : (
                                                                                <>
                                                                                    <Dropdown.Item
                                                                                        href="#"
                                                                                        className="d-flex align-items-center"
                                                                                        onClick={() => {
                                                                                            if (!quotationGrant?.isEdit) {
                                                                                                toast.warning(
                                                                                                    "You are not authorized for this action!"
                                                                                                );
                                                                                                return;
                                                                                            }
                                                                                            navigate(
                                                                                                `/editquotation/${quotation?.quotation_id}`,
                                                                                                { state: { mode: "edit" } }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={faEdit}
                                                                                            style={{
                                                                                                width: "16px",
                                                                                                height: "16px",
                                                                                                marginRight: "9px",
                                                                                                color: "#5e5f60",
                                                                                            }}
                                                                                        />
                                                                                        Edit
                                                                                    </Dropdown.Item>
                                                                                    <Dropdown.Item
                                                                                        href="#"
                                                                                        className="d-flex align-items-center"
                                                                                        onClick={() => {
                                                                                            if (!quotationGrant?.isRevised) {
                                                                                                toast.warning(
                                                                                                    "You are not authorized for this action!"
                                                                                                );
                                                                                                return;
                                                                                            }
                                                                                            navigate(
                                                                                                `/editquotation/${quotation?.quotation_id}`,
                                                                                                { state: { mode: "clone" } }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={faClone}
                                                                                            style={{
                                                                                                width: "16px",
                                                                                                height: "16px",
                                                                                                marginRight: "9px",
                                                                                                color: "#5e5f60",
                                                                                            }}
                                                                                        />
                                                                                        Revised
                                                                                    </Dropdown.Item>
                                                                                </>
                                                                            )}
                                                                            <Dropdown.Item
                                                                                href="#"
                                                                                className="d-flex align-items-center"
                                                                                onClick={() => {
                                                                                    if (!quotationGrant?.isDelete) {
                                                                                        toast.warning(
                                                                                            "You are not authorized for this action!"
                                                                                        );
                                                                                    }
                                                                                    quotation.quotation_status === "approved"
                                                                                        ? handleCancelQuotation(quotation)
                                                                                        : onDelete(quotation.quotation_id);
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={
                                                                                        quotation.quotation_status === "approved"
                                                                                            ? faCancel
                                                                                            : faTrash
                                                                                    }
                                                                                    style={{
                                                                                        width: "16px",
                                                                                        height: "16px",
                                                                                        marginRight: "9px",
                                                                                        color: "#5e5f60",
                                                                                    }}
                                                                                />
                                                                                {quotation.quotation_status === "approved"
                                                                                    ? "Cancel"
                                                                                    : "Delete"}
                                                                            </Dropdown.Item>
                                                                            {quotation.quotation_status === "approved" && (
                                                                                <Dropdown.Item
                                                                                    href="#"
                                                                                    className="d-flex align-items-center"
                                                                                    onClick={() =>
                                                                                        quotation.quotation_status === "approved" &&
                                                                                        handleSendQuotation(quotation.quotation_id)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={faMailForward}
                                                                                        style={{
                                                                                            width: "16px",
                                                                                            height: "16px",
                                                                                            marginRight: "9px",
                                                                                            color: "#5e5f60",
                                                                                        }}
                                                                                    />
                                                                                    {loading ? "Sending" : "Send Mail"}
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            )}
                                    </>
                                )}
                                {dataToDisplay?.length > 10 && (
                                    <tr
                                        className="no-hover-row"
                                        style={{
                                            backgroundColor: "#ffffff",
                                            marginTop: "0px !important",
                                            marginBottom: "0px !important",
                                        }}

                                    >
                                        <td
                                            colSpan={12}
                                            style={{ backgroundColor: "#ffffff" }}
                                        >
                                            <div style={{ padding: 0 }}>
                                                <div
                                                    className="d-flex justify-content-between align-items-center gap-2 mt-"
                                                    style={{
                                                        padding: "0.7rem 0",
                                                    }}
                                                >
                                                    <div className="pagination-left">
                                                        <p
                                                            className="mb-0"
                                                            style={{
                                                                fontSize: "14px",
                                                                paddingRight: "10rem",
                                                            }}
                                                        >
                                                            {/* Showing {offset + 1} of{" "} */}
                                                            Showing {activeOffset + 1} of{" "} {pageCount !== 0
                                                                ? pageCount
                                                                : pageCount + 1}
                                                        </p>
                                                    </div>
                                                    <div className="pagination-right d-flex gap-2 align-items-center">
                                                        <select
                                                            style={{ minWidth: "78px" }}
                                                            onChange={(e) => {
                                                                setLimit(Number(e.target.value));
                                                                setActiveOffset(0);
                                                            }}
                                                            id="limit"
                                                            className="form-control form-select"
                                                        >
                                                            <option value={25}>25</option>
                                                            <option value={100}>100</option>
                                                            <option value={200}>200</option>
                                                            <option value={300}>300</option>
                                                        </select>
                                                        <div className="d-flex align-items-center gap-3">
                                                            <Pagination
                                                                offset={activeOffset}
                                                                setOffset={setActiveOffset}
                                                                handlePageChange={handlePageChange}
                                                                pageCount={pageCount}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {dataToDisplay?.length <= 10 && (
                        <div
                            style={{
                                padding: "0.5rem 0",
                                backgroundColor: "white",
                                borderTop: "1px solid #e0e0e0",
                                width: "100%",
                                overflowX: "auto",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center gap-2">
                                <div className="pagination-left">
                                    <p className="mb-0" style={{ fontSize: "14px" }}>
                                        {/* Showing {offset + 1} of{" "} */}
                                        Showing {activeOffset + 1} of{' '} {pageCount !== 0 ? pageCount : pageCount + 1}
                                    </p>
                                </div>
                                <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                        style={{ minWidth: "78px" }}
                                        onChange={(e) => {
                                            setLimit(Number(e.target.value));
                                            setActiveOffset(0);
                                        }}
                                        id="limit"
                                        className="form-control form-select"
                                    >
                                        <option value={25}>25</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                        <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                        <Pagination
                                            offset={activeOffset}
                                            setOffset={setActiveOffset}
                                            handlePageChange={handlePageChange}
                                            pageCount={pageCount}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showModal && (
                        <Modal show={showModal} onHide={handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Cancel Quotation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <>
                                    <p>Are you sure you want to cancel the quotation?</p>
                                    <Form.Group controlId="rejectReason">
                                        <Form.Label>Reason</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={rejectReason}
                                            onChange={(e) => setRejectReason(e.target.value)}
                                        />
                                    </Form.Group>
                                </>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    className="btn btn-default-outline me-2"
                                    onClick={handleCloseModal}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="btn btn-default"
                                    onClick={handleConfirm}
                                    disabled={rejectReason.trim() === ""}
                                >
                                    {loading ? "submiting.." : "Confirm"}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                </div>
            </Container >
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmedDelete}
                message="Are you sure you want to delete this item?"
                isLoading={loading}
            />
        </>
    )
}
